export enum InterferenceDetector {
  Monitor,
  Marker,
  Mask,
  Threshold,
}
